import Vue from 'vue'
import Router from 'vue-router'
import {main} from './mod/main.route'
import {auth} from './mod/auth.route'
import {info} from './mod/info.route'
import {reg} from './mod/reg.route'
import {tel} from './mod/tel.route'
import {elder} from './mod/elder.route'
import {chat} from './mod/chat.route'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/m/',
  routes: [
    ...auth,
    ...main,
    ...info,
    ...reg,
    ...tel,
    ...elder,
    ...chat,
    {path: '*', redirect: '/login'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js